export default {
  title: 'Что нового в Arena',
  since: 'Начиная с версии {{version}}',
  experimental: 'Экспериментально',
  dontShowAgain: 'Больше не показывать',
  slideCounter: '{{current}} из {{total}}',
  noItems: 'Нет новых функций для показа.',
  items: {
    dataMatrixExport: {
      title: `Экспорт данных в виде матрицы`,
      description: `В разделе **Данные > Проводник** выберите множественную сущность (например, виды каждой записи), нажмите **Экспорт** и выберите **Экспортировать как: Матрица данных**, чтобы получить таблицу с одной строкой на вид (или другой атрибут) и одним столбцом на запись, с выбранным значением в ячейках (например, покрытие).

Этот формат нужен инструментам анализа растительности, таким как **Turboveg**, **Juice** и **Synbiosys**. Задайте фильтр в Проводнике, чтобы экспортировать только некоторые записи.`,
    },
    mobilePreview: {
      title: 'Предварительный просмотр анкеты в Arena Mobile',
      description: `В конструкторе форм откройте меню рядом с кнопкой **Предварительный просмотр** и выберите **Предварительный просмотр (мобильный)**, чтобы опробовать черновик анкеты так, как он выглядит в **Arena Mobile**, на телефоне или планшете, в книжной или альбомной ориентации.

Просмотр выполняется в браузере: некоторые возможности реального устройства (например, карты и камера) недоступны.`,
    },
    requiredIf: {
      title: 'Атрибуты, обязательные по условию',
      description: `В конструкторе форм на вкладке **Проверки** атрибута выберите **Обязательно при выполнении условия** и задайте условие: атрибут будет обязательным только тогда, когда условие истинно.

При вводе данных ошибка «Требуемое значение» показывается только при выполнении условия.`,
    },
    themeSelector: {
      title: 'Светлая и тёмная тема',
      description: `В меню **Тема** в заголовке (а также на странице входа) можно переключаться между **Светлой** и **Тёмной** темой или использовать **Системную**.`,
    },
    surveyCompare: {
      title: 'Сравнение и обновление опросов',
      description: `На **Панели управления** используйте **Расширенные функции > Сравнить / обновить из файла**, чтобы сравнить этот опрос с опросом, экспортированным с другого сервера Arena (например, тестового), или с другим опросом на этом сервере.

Просмотрите различия и примените только выбранные изменения: они сохраняются как черновик до публикации опроса.`,
    },
    usersBackup: {
      title: 'Резервное копирование и восстановление пользователей',
      description: `В разделе **Пользователи** используйте **Резервное копирование / Восстановление**, чтобы экспортировать всех пользователей с их ролями в опросах и группами пользователей и восстановить их на другом сервере Arena.

Перед восстановлением можно выбрать действие для каждого пользователя.`,
    },
    samplingPointDataWhisp: {
      title: 'Анализ Whisp для точек выборки',
      description: `В категории **данных точек выборки** используйте **Сгенерировать анализ Whisp**, чтобы проанализировать все местоположения точек выборки с помощью **Open Foris Whisp**.

Анализ выполняется в фоновом режиме, а результаты сохраняются в новой категории.`,
    },
    dashboardUpgrade: {
      title: 'Новая панель управления',
      description: `**Панель управления** получила новый вид: записи и участники с первого взгляда, карта собранных данных и динамика добавления записей.`,
    },
    clearNonApplicableValues: {
      title: 'Неактуальные значения очищаются',
      description: `При вводе данных, когда изменение делает другие поля неактуальными, их значения очищаются после вашего подтверждения.

Администраторы опроса могут сохранить прежнее поведение с помощью **Сохранять значения неактуальных атрибутов** (**Информация об опросе > Безопасность**).`,
    },
    systemLogs: {
      title: 'Системные журналы',
      description: `В разделе **Администрирование системы > Системные журналы** следите за журналами сервера в реальном времени, с фильтрами по тексту и уровню.`,
    },
    dataQueryAiGenerate: {
      title: 'Создание запросов в Обозревателе данных с помощью ИИ',
      description: `В **Обозревателе данных** опишите нужные данные обычным языком (например, *«количество деревьев по видам в каждой провинции»*), и ИИ построит запрос за вас.

ИИ также может предложить название и описание при сохранении запроса.

*Требуется включить функции ИИ в профиле пользователя.*`,
    },
    recordPrint: {
      title: 'Печать записей',
      description: `Экспортируйте запись в печатный документ **Word** или **PDF** (включая изображения) с помощью кнопки PDF в редакторе записи.

Можно выбрать ориентацию страницы (книжная или альбомная).`,
    },
    attributeClone: {
      title: 'Клонирование атрибутов в конструкторе форм',
      description: `В **конструкторе форм** используйте меню атрибута, чтобы **клонировать** его в ту же или другую сущность со всеми его свойствами.`,
    },
    odkImport: {
      title: 'Импорт опросов и данных из ODK',
      description: `Создайте новый опрос из **формы ODK (.xml)** и импортируйте данные, собранные с помощью **ODK Collect**.

*Эта функция находится в бета-версии.*`,
    },
    dynamicEnumerator: {
      title: 'Динамическое перечисление сущностей',
      description: `Используйте **выражение**, чтобы выбрать, какие элементы категории создают строки перечисляемой множественной сущности: например, \`unique(plot.land_use)\` создаёт строки только для типов землепользования, встречающихся на участках.`,
    },
  },
}
